import { IMusicPlayerController } from '../MusicPlayer.types';

const mapActionsToProps: IMusicPlayerController = ({ updateProps }) => ({
  onVolumeChanged: volume => {
    updateProps({ volume });
  },
  onMuteChanged: muted => {
    updateProps({ muted });
  },
  onPlay: () => {
    updateProps({ isPlaying: true });
  },
  onPause: () => {
    updateProps({ isPlaying: false });
  },
  onEnded: () => {
    updateProps({ isPlaying: false });
  },
  onTimeUpdated: currentTime => {
    updateProps({ currentTime });
  },
});

export default mapActionsToProps;
